export default "__VITE_ASSET__CczIakSo__"